import { Routes } from '@angular/router';
import { ActivateFeedComponent } from './components/activate-feed/activate-feed.component';
import { InvalidOtpComponent } from './components/invalid-otp/invalid-otp.component';
import { UnavailableFeedComponent } from './components/unavailable-feed/unavailable-feed.component';
import { HospitalTheatreCasesFeedComponent } from './components/hospital-theatre-cases-feed/hospital-theatre-cases-feed.component';
import { FeedTypeNotSupportedComponent } from './components/feed-type-not-supported/feed-type-not-supported.component';

export const routes: Routes = [
    { path: '', redirectTo: 'activate', pathMatch: 'full' },
    { path: 'activate', component: ActivateFeedComponent },
    { path: 'invalid-otp', component: InvalidOtpComponent },
    { path: 'unavailable', component: UnavailableFeedComponent },
    { path: 'hospital-theatre-cases', component: HospitalTheatreCasesFeedComponent },
    { path: 'feed-type-not-supported', component: FeedTypeNotSupportedComponent }
];
